import { motion } from "framer-motion";

const nodes = [
  {
    label: "Discover",
    sub: "Customers click your TapToTable link from Instagram or Facebook posts, your social bio, Google Business Profile, website, email, QR codes, or anywhere else you share it.",
  },
  {
    label: "Explore",
    sub: "They instantly see your restaurant, current promotion or event, photos, contact information, hours, and directions—all in one focused mobile page.",
  },
  {
    label: "Act",
    sub: "They can claim a promotion or take an event action such as RSVP, reserve a table, get tickets, join a guest list, visit your website, call, or get directions.",
  },
  {
    label: "Visit",
    sub: "They have a clear reason and an easy path to visit, order, attend, or come back—turning online interest into real customer activity.",
  },
];

export default function FlowDiagram() {
  return (
    <section
      className="py-24 md:py-32 px-6 md:px-12 border-t border-white/5"
      data-testid="flow-diagram-section"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto"
        >
          <div className="label-caps">Your Customer&apos;s Journey</div>

          <h2 className="mt-3 font-display font-semibold text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-tight">
            Turn Online Visitors Into Restaurant Customers
          </h2>

          <p className="mt-4 text-zinc-400 text-base sm:text-lg max-w-2xl mx-auto">
            TapToTable gives customers a simple path from discovering your
            business to responding to a promotion or event and taking the next
            step.
          </p>
        </motion.div>

        <div className="relative mt-16 grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-0">
          <div className="hidden md:block absolute top-10 left-[12%] right-[12%] h-[2px] bg-gradient-to-r from-transparent via-[#00E5FF]/50 to-transparent" />

          {nodes.map((node, index) => (
            <motion.div
              key={node.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: index * 0.12, duration: 0.5 }}
              className="relative flex flex-col items-center text-center px-4"
              data-testid={`flow-node-${index}`}
            >
              <div className="relative h-20 w-20 rounded-full bg-[#121214] border border-[#00E5FF]/30 flex items-center justify-center text-[#00E5FF] font-display font-semibold text-xl shadow-[0_0_30px_rgba(0,229,255,0.15)]">
                {index + 1}

                <span className="absolute inset-0 rounded-full border border-[#00E5FF]/20 animate-ping" />
              </div>

              <div className="mt-5 font-display font-semibold text-lg">
                {node.label}
              </div>

              <div className="mt-2 text-sm text-zinc-400 leading-relaxed max-w-[240px]">
                {node.sub}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
